import 'moment-timezone';
import moment from "moment-timezone";
import { Message } from 'primereact/message';
import { SplitButton } from 'primereact/splitbutton';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AiOutlinePlus } from "react-icons/ai";
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { BadgeStatus, getEndpointUrl, getTimestamp } from '../../Utils/Common';
import ModalDeletePurchaseInvoice from "./ModalDeletePurchaseInvoice";
import ModalSetStatus from './ModalSetStatus';

const ListPurchaseInvoice = ({ props }) => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [options] = useState(
        JSON.parse(localStorage.getItem('options')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [query, setQuery] = useSearchParams();

    const [isLoading, setLoading] = useState(false);

    const navigate = useNavigate();

    const [items, setItems] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const inputRef = useRef();
    const timeout = useRef();
    const [searchQuery, setSearchQuery] = useState('');

    const [selectedData, setSelectedData] = useState([]);

    const [confirmDialog, setConfirmDialog] = useState(false);

    const [devStatus, setDevStatus] = useState('pending');

    const [confirmSetStatusDialog, setConfirmSetStatusDialog] = useState(false);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const fetchData = async () => {
        setLoading(true);
        try {

            const response = await fetch(getEndpointUrl() + `/purchase?page=${page}&per_page=${5}&query=${searchQuery}&v=${getTimestamp()}` +
                `&status=${(query.get('status') !== null) ? query.get('status') : ''}` +
                `&startDate=${(query.get('startDate') !== null) ? query.get('startDate') : ''}` +
                `&endDate=${(query.get('endDate') !== null) ? query.get('endDate') : ''}`,
                {
                    headers: new Headers({
                        Authorization: `Bearer ${accesToken}`,
                        // pragma: 'no-cache',
                    })
                });
            const data = await response.json();
            if (data.status === 'ok') {
                setItems([...new Set([...items, ...data.results.data])]);

                setPage(prevPage => prevPage + 1);

                if (items.length >= data.results.total)
                    setHasMore(false);
            }


        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {

    }, [page]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!searchQuery.trim()) {
            fetchData()
            return
        }

        timeout.current = setTimeout(() => {
            fetchData();
        }, 600);
    }, [searchQuery, query]);

    const onSearchQuery = (e) => {
        setLoading(true);
        setHasMore(true);
        setPage(0);
        setItems([]);
        setSearchQuery(e.target.value);
    }

    const onCallback = useCallback((e) => {
        setLoading(true);
        setHasMore(true);
        setPage(0);
        setItems([]);
        fetchData();
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setHasMore(true);
        setPage(0);
        setItems([]);
        query.set('status', e.target.status.value);
        query.set('startDate', (e.target.startDate.value !== '') ? moment(e.target.startDate.value).format('YYYY-MM-DD') : '');
        query.set('endDate', (e.target.endDate.value !== '') ? moment(e.target.endDate.value).format('YYYY-MM-DD') : '');
        setQuery(query);

        fetchData();
    };

    const resetFilter = (e) => {
        setSearchQuery('');
        setSearchQuery('');
        setStartDate('');
        setEndDate('');

        setLoading(true);
        setHasMore(true);
        setPage(0);
        setItems([]);

        navigate('/pembayaran');

        fetchData();
    }

    return (
        <>
            <Container>
                <Row className="mb-3">
                    <Col>
                        <Link to={'/pembayaran/create'} title="Input Pembayaran" className="btn btn-success"><AiOutlinePlus className="me-2" /> Input Pembayaran</Link>
                    </Col>
                </Row>
                <Form onSubmit={onSubmit}>
                    <Row className="mb-3">
                        <Col md={3} className="mb-3">
                            <Form.Group>
                                <Form.Control type="text" name="query" ref={inputRef} value={searchQuery} onChange={onSearchQuery} autoComplete="off" placeholder="Pencarian..." />
                            </Form.Group>
                        </Col>
                        <Col md={2} className="mb-3">
                            <Form.Select name="status">
                                <option value="">- Semua Status -</option>
                                <option value="pending" defaultValue={query.get('status') == 'pending'} >Pending/Belum dibayar</option>
                                <option value="draft" defaultValue={query.get('status') == 'draft'}>Draft</option>
                                <option value="lunas" defaultValue={query.get('status') == 'lunas'}>Lunas</option>
                            </Form.Select>
                        </Col>
                        <Col xs={6} className="mb-3">
                            <DatePicker
                                startDate={startDate}
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                autoComplete="off"
                                placeholderText="Mulai tanggal"
                                name="startDate"
                                customInput={<Form.Control />} />
                        </Col>
                        <Col xs={6} className="mb-3">
                            <DatePicker
                                startDate={startDate}
                                minDate={startDate}
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                autoComplete="off"
                                placeholderText="Sampai tanggal"
                                name="endDate"
                                customInput={<Form.Control />} />
                        </Col>
                        <Col md={3}>
                            <Button type="submit">Filter Data</Button>
                            <Button type="button" variant="secondary" onClick={resetFilter} className="ms-2">Reset</Button>
                        </Col>
                    </Row>
                </Form>
            </Container>
            <InfiniteScroll
                dataLength={items.length}
                next={fetchData}
                hasMore={hasMore}
                style={{ padding: '0px', margin: '0px' }}>
                {items.length > 0 ? items.map(value => (
                    <Container key={value.id}>
                        <Row>
                            <Col>
                                <div className="border rounded-3 px-3 py-3 mb-3">
                                    <div className="d-flex justify-content-between border-bottom">
                                        <div>
                                            <BadgeStatus status={value.purchaseStatus} />
                                        </div>
                                        <div className="ms-auto mb-2">

                                            <SplitButton size="small" label="Detil" icon="pi pi-eye"
                                                onClick={(e) => navigate(`/pembayaran/cetak/${value.id}`)}
                                                model={[
                                                    {
                                                        label: 'Edit',
                                                        icon: 'pi pi-pencil',
                                                        disabled: userLogin.role != 'admin',
                                                        command: () => navigate(`/pembayaran/update/${value.id}`)
                                                    },
                                                    {
                                                        label: 'Lunas',
                                                        icon: 'pi pi-check',
                                                        disabled: userLogin.role != 'admin',
                                                        command: () => {
                                                            setDevStatus('lunas');
                                                            setSelectedData(value);
                                                            setConfirmSetStatusDialog(true);
                                                        }
                                                    },
                                                    {
                                                        label: 'Pending/Menunggu Pembayaran',
                                                        icon: 'pi pi-times',
                                                        disabled: userLogin.role != 'admin',
                                                        command: () => {
                                                            setDevStatus('pending');
                                                            setSelectedData(value);
                                                            setConfirmSetStatusDialog(true);
                                                        }
                                                    },
                                                    {
                                                        label: 'Hapus',
                                                        icon: 'pi pi-trash',
                                                        disabled: userLogin.role != 'admin',
                                                        command: () => {
                                                            setSelectedData(value);
                                                            setConfirmDialog(true);
                                                        }
                                                    }
                                                ]} severity="secondary" text />
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <small className="text-muted">ID  <span className="fw-bold"> {value.id}</span></small><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>TGL DIBUAT</small><br />
                                        <span className="fw-normal fst-italic"><Moment format="DD/MM/YYYYY - HH:mm A">{value.createdAt}</Moment></span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>NAMA PELANGGAN</small><br />
                                        <span className="fw-bold">{value.invoice.customerName}</span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>NO HANDPHONE</small><br />
                                        <span className="fw-medium">{value.invoice.customerPhone}</span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>TGL BAYAR</small><br />
                                        <span className="fw-normal fst-italic"><Moment format="DD/MM/YYYY">{value.purchaseDate}</Moment></span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>TOTAL TAGIHAN</small><br />
                                        <span className="fw-normal">
                                            <NumericFormat
                                                value={value.amount}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                className="fw-medium"
                                                prefix={'Rp'}
                                                renderText={(value, props) => <span {...props}>{value}</span>} />
                                        </span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>TOTAL BAYAR</small><br />
                                        <span className="fw-normal">
                                            <NumericFormat
                                                value={value.amountPaid}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                className="fw-medium"
                                                prefix={'Rp'}
                                                renderText={(value, props) => <span {...props}>{value}</span>} />
                                        </span><br />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                )) : !isLoading &&
                <Row>
                    <Col>
                        <Message severity="warn" text="Ups, Data penawaran tidak tersedia!" style={{ display: 'block' }} />
                    </Col>
                </Row>
                }
            </InfiniteScroll>
            {/* Confirm Dialog */}
            <ModalDeletePurchaseInvoice row={selectedData} onCallback={(e) => onCallback(e)} show={confirmDialog} close={() => setConfirmDialog(false)} />
            <ModalSetStatus row={selectedData} onCallback={(e) => onCallback(e)} show={confirmSetStatusDialog} close={() => setConfirmSetStatusDialog(false)} status={devStatus} />

            <Container>
                {isLoading &&
                    <Row>
                        <Col className="d-flex justify-content-center mt-3">
                            <Loader type="bubble-scale" bgColor={"#5772b8"} size={100} />
                        </Col>
                    </Row>
                }
            </Container>
        </>
    );
}

export default ListPurchaseInvoice;